var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "mt-4" },
    [
      _vm.orders === null
        ? [_c("loader")]
        : [
            _vm.orders.length === 0 && _vm.queryData.page === 0
              ? [
                  _c("notification", {
                    attrs: { classname: "alert-info", body: "message.no_data" }
                  })
                ]
              : [
                  _vm._l(_vm.orders, function(order, index) {
                    return _c(
                      "div",
                      {
                        key: order.id,
                        staticClass: "card",
                        class: {
                          "border border-danger":
                            order.declined_order_data &&
                            order.status === 0 &&
                            order.selected_professional_id != 0
                        }
                      },
                      [
                        _c("ul", { staticClass: "list-unstyled mb-0" }, [
                          _c(
                            "li",
                            { staticClass: "card-body" },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "text-order",
                                  attrs: { to: _vm.conditionOrder(order) }
                                },
                                [
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-9 col-lg-8 p-0" },
                                      [
                                        _vm._v(
                                          "\n                  #" +
                                            _vm._s(order.order_code) +
                                            "\n                  -\n                  "
                                        ),
                                        _c("span", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.$options.filters.serviceParentName(
                                                order.service_id,
                                                _vm.globalState.services
                                              )
                                            )
                                          }
                                        }),
                                        _vm._v(" "),
                                        order.sent_photo_status === 1
                                          ? _c("img", {
                                              staticClass: "ml-1",
                                              attrs: {
                                                src:
                                                  "/static/img/ic_badge_photo.png",
                                                height: "24"
                                              }
                                            })
                                          : _vm._e()
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-3 col-lg-4 text-right p-0"
                                      },
                                      [
                                        !order.service_request
                                          ? _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.$options.filters.orderStatus(
                                                    order
                                                  )
                                                )
                                              }
                                            })
                                          : _vm._e()
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "row mt-3 align-items-end" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "col-9 col-lg-8 p-0" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "float-left" },
                                            [
                                              order.professional === null &&
                                              order.selected_professional ===
                                                null
                                                ? [
                                                    _c("img", {
                                                      staticClass:
                                                        "rounded-circle message-user-img",
                                                      attrs: {
                                                        src:
                                                          "https://beneat.co/static/img/unknown.png"
                                                      }
                                                    })
                                                  ]
                                                : order.professional
                                                ? [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "professional-picture-box"
                                                      },
                                                      [
                                                        _c(
                                                          "professional-picture",
                                                          {
                                                            attrs: {
                                                              professional:
                                                                order.professional,
                                                              imgClass:
                                                                "message-user-img",
                                                              imgSize: 36
                                                            }
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                : [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "professional-picture-box"
                                                      },
                                                      [
                                                        _c(
                                                          "professional-picture",
                                                          {
                                                            attrs: {
                                                              professional:
                                                                order.selected_professional,
                                                              imgClass:
                                                                order.declined_order_data &&
                                                                order.status ===
                                                                  0
                                                                  ? "message-user-img border border-danger"
                                                                  : "message-user-img",
                                                              imgSize: 36
                                                            }
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "float-left ml-3" },
                                            [
                                              order.user_place
                                                ? _c("div", [
                                                    _vm._v(
                                                      _vm._s(
                                                        order.user_place
                                                          .place_name
                                                      )
                                                    )
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "text-order-date"
                                                },
                                                [
                                                  order.cleaning_date
                                                    ? _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f("shortDate")(
                                                              order.cleaning_date
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    : _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "message.my_reservations.booking_date_not_specified"
                                                            )
                                                          )
                                                        )
                                                      ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                [
                                                  order.service_id === 1
                                                    ? [
                                                        order.cleaning_date
                                                          ? _c("span", [
                                                              _vm._v(
                                                                "\n                          " +
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "onlyTime"
                                                                    )(
                                                                      order.cleaning_date
                                                                    )
                                                                  ) +
                                                                  " • " +
                                                                  _vm._s(
                                                                    order.work_hour
                                                                  ) +
                                                                  " " +
                                                                  _vm._s(
                                                                    _vm.$tc(
                                                                      "message.hour",
                                                                      order.work_hour
                                                                    )
                                                                  ) +
                                                                  "\n                        "
                                                              )
                                                            ])
                                                          : _c("span", [
                                                              _vm._v(
                                                                "\n                          " +
                                                                  _vm._s(
                                                                    order.work_hour
                                                                  ) +
                                                                  " " +
                                                                  _vm._s(
                                                                    _vm.$tc(
                                                                      "message.hour",
                                                                      order.work_hour
                                                                    )
                                                                  ) +
                                                                  "\n                        "
                                                              )
                                                            ])
                                                      ]
                                                    : order.order_service_items &&
                                                      order.order_service_items
                                                        .length
                                                    ? [
                                                        order.cleaning_date
                                                          ? _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "onlyTime"
                                                                  )(
                                                                    order.cleaning_date
                                                                  )
                                                                ) + " •"
                                                              )
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "message.service_item.qty"
                                                              )
                                                            ) +
                                                            " " +
                                                            _vm._s(
                                                              _vm.getServiceItemsQty(
                                                                order.order_service_items
                                                              )
                                                            ) +
                                                            " \n                      "
                                                        )
                                                      ]
                                                    : [
                                                        order.cleaning_date
                                                          ? _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "onlyTime"
                                                                  )(
                                                                    order.cleaning_date
                                                                  )
                                                                )
                                                              )
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        order.work_hour
                                                          ? _c("span", [
                                                              _vm._v(
                                                                " • " +
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "multiLangName"
                                                                    )(
                                                                      _vm
                                                                        .globalState
                                                                        .services[
                                                                        order
                                                                          .service_id
                                                                      ]
                                                                    )
                                                                  )
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ],
                                                  _vm._v(" "),
                                                  _vm.$options.filters.orderAdditionalHours(
                                                    order
                                                  )
                                                    ? _c("span", [
                                                        _vm._v(
                                                          "\n                         " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "orderAdditionalHours"
                                                              )(order)
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ])
                                                    : _vm._e()
                                                ],
                                                2
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "clearfix" })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-3 col-lg-4 text-right p-0"
                                        },
                                        [
                                          order.subscription_id
                                            ? _c(
                                                "span",
                                                { staticClass: "text-orange" },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fal fa-calendar-alt"
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.subscription.title"
                                                        )
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          order.package_id
                                            ? _c(
                                                "span",
                                                { staticClass: "text-orange" },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fal fa-layer-group"
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm._f("multiLangName")(
                                                          order.package
                                                            .package_type
                                                        )
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          order.host_id
                                            ? _c(
                                                "span",
                                                { staticClass: "text-orange" },
                                                [
                                                  _c("i", {
                                                    staticClass: "fal fa-bed"
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.my_reservations.for_host"
                                                        )
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !order.package_id &&
                                          order.is_no_datetime_booking &&
                                          order.status < 1
                                            ? _c(
                                                "span",
                                                { staticClass: "text-orange" },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.booking.new_booking.booking_type_flexible"
                                                        )
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  order.service_request
                                    ? _c("div", { staticClass: "pt-3" }, [
                                        _c("div", [
                                          _c("i", {
                                            staticClass: "fal fa-map-marker-alt"
                                          }),
                                          _vm._v(
                                            "  " +
                                              _vm._s(
                                                order.service_request
                                                  .building_address
                                              ) +
                                              "\n                "
                                          )
                                        ]),
                                        _vm._v(" "),
                                        order.service_request.payment_status ===
                                        0
                                          ? _c("div", { staticClass: "pt-2" }, [
                                              _c("i", {
                                                staticClass:
                                                  "fal fa-file-alt -status-new"
                                              }),
                                              _vm._v(
                                                "  " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.service_request.service_request_document"
                                                    )
                                                  ) +
                                                  "\n                "
                                              )
                                            ])
                                          : _vm._e()
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  order.status < 2
                                    ? _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-12 p-0" },
                                          [
                                            order.paid_status === 1 &&
                                            order.cleaning_date &&
                                            !order.confirm_cleaning_date &&
                                            !order.declined_order_data
                                              ? [
                                                  _c("hr"),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-order-notification"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "bullet-notification"
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fas fa-circle -status-pending"
                                                          })
                                                        ]
                                                      ),
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "message.my_reservations.no_confirm_cleaning_datetime"
                                                            )
                                                          ) +
                                                          "\n                    "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              : _vm._e(),
                                            _vm._v(" "),
                                            (order.payment_method ===
                                              "bank_transfer" ||
                                              order.payment_method ===
                                                "promptpay") &&
                                            !order.has_bank_transferred
                                              ? [
                                                  _c("hr"),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-order-notification"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "bullet-notification"
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fas fa-circle"
                                                          })
                                                        ]
                                                      ),
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.unpaidBankTransferNotification(
                                                              order
                                                            )
                                                          ) +
                                                          "\n                    "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              : _vm._e(),
                                            _vm._v(" "),
                                            order.declined_order_data &&
                                            order.status === 0 &&
                                            order.selected_professional_id === 0
                                              ? [
                                                  _c("hr"),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-order-notification"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "bullet-notification"
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fas fa-circle"
                                                          })
                                                        ]
                                                      ),
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "message.my_reservations.finding_new_cleaner"
                                                            )
                                                          ) +
                                                          "\n                    "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              : _vm._e(),
                                            _vm._v(" "),
                                            order.revise_datetime_data ||
                                            _vm.displayAdditionalHoursNotification(
                                              order
                                            )
                                              ? [
                                                  order.revise_datetime_data ||
                                                  _vm.displayAdditionalHoursNotification(
                                                    order
                                                  )
                                                    ? _c("hr")
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  order.revise_datetime_data
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "text-order-notification"
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "bullet-notification"
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "fas fa-circle"
                                                              })
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          order
                                                            .revise_datetime_data
                                                            .sender_type ===
                                                          "user"
                                                            ? _c("span", [
                                                                _vm._v(
                                                                  "\n                        " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "message.my_reservations.you_want_to_change_date_time"
                                                                      )
                                                                    ) +
                                                                    "\n                      "
                                                                )
                                                              ])
                                                            : _c("span", [
                                                                _vm._v(
                                                                  "\n                        " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "message.my_reservations.cleaner_want_to_change_date_time"
                                                                      )
                                                                    ) +
                                                                    "\n                      "
                                                                )
                                                              ])
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.displayAdditionalHoursNotification(
                                                    order
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "text-order-notification"
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "bullet-notification"
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "fas fa-circle"
                                                              })
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.displayAdditionalHoursNotification(
                                                                  order
                                                                )
                                                              )
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              : _vm._e(),
                                            _vm._v(" "),
                                            order.status === 0 &&
                                            order.declined_order_data &&
                                            order.selected_professional_id > 0
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-order-notification"
                                                  },
                                                  [
                                                    _c("hr"),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "bullet-notification"
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-circle -status-alert"
                                                        })
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "-status-alert"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "message.declined_booking.cleaner_declined_booking"
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "-status-alert mt-1"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      - " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "declinedReason"
                                                              )(
                                                                order.declined_order_data
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            order.pre_booking_professionals &&
                                            order.status === 0
                                              ? [
                                                  _c("hr"),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex justify-content-start align-content-center text-order-notification"
                                                    },
                                                    [
                                                      _c("div", [
                                                        _c("img", {
                                                          attrs: {
                                                            src:
                                                              "/static/img/switch_professional.svg"
                                                          }
                                                        })
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        { staticClass: "px-2" },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "message.booking.switch_professional.offer_pre_booking_professionals"
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        _vm._l(
                                                          order.pre_booking_professionals,
                                                          function(
                                                            professional,
                                                            index
                                                          ) {
                                                            return _c("span", [
                                                              _c("img", {
                                                                staticClass:
                                                                  "rounded-circle",
                                                                class: [
                                                                  index === 0
                                                                    ? "img-pre-booking-professional-first"
                                                                    : "img-pre-booking-professional-other"
                                                                ],
                                                                attrs: {
                                                                  src:
                                                                    professional.full_picture,
                                                                  width: "24"
                                                                }
                                                              })
                                                            ])
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    ]
                                                  )
                                                ]
                                              : _vm._e(),
                                            _vm._v(" "),
                                            order.status === 1 &&
                                            _vm.$options.filters.professionalJobStatus(
                                              order,
                                              false
                                            )
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-order-notification"
                                                  },
                                                  [
                                                    _c("hr"),
                                                    _vm._v(" "),
                                                    _c("div", {
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          _vm.$options.filters.professionalJobStatus(
                                                            order,
                                                            false
                                                          )
                                                        )
                                                      }
                                                    })
                                                  ]
                                                )
                                              : _vm._e()
                                          ],
                                          2
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  order.service_request
                                    ? [
                                        _c("hr"),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text-order-notification"
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "bullet-notification-yellow"
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fas fa-circle -status-pending"
                                                })
                                              ]
                                            ),
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm._f("multiLangName")(
                                                    order.service_request
                                                      .service_request_status
                                                  )
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  order.status === 2 && order.cancel === 0
                                    ? [
                                        _c("div", { staticClass: "row" }, [
                                          _c(
                                            "div",
                                            { staticClass: "col-12 p-0" },
                                            [
                                              !order.is_received_order &&
                                              !order.order_report_issue
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex justify-content-start align-items-center mt-3"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "flex-fill"
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fas fa fa-circle fa-sm text-info"
                                                          }),
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "message.received_order.please_accept"
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "flex-fill"
                                                        },
                                                        [
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "btn btn-block btn-info",
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  $event.preventDefault()
                                                                  return _vm.openReceivedOrderModal(
                                                                    index,
                                                                    order.id
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "message.button.received_order"
                                                                    )
                                                                  ) +
                                                                  "\n                        "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex justify-content-start align-items-center mt-3"
                                                    },
                                                    [
                                                      order.is_received_order &&
                                                      order.is_reviewed
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "-status-accepted"
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "fas fa fa-circle fa-sm"
                                                              }),
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "message.my_reservations.reviewed"
                                                                    )
                                                                  ) +
                                                                  "\n                      "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "text-right flex-fill"
                                                        },
                                                        [
                                                          (order.is_received_order ||
                                                            order.order_report_issue) &&
                                                          !order.is_reviewed &&
                                                          order.review_days > 0
                                                            ? _c(
                                                                "button",
                                                                {
                                                                  staticClass:
                                                                    "btn btn-success",
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      $event.preventDefault()
                                                                      return _vm.openReviewModal(
                                                                        index,
                                                                        order.id,
                                                                        order.professional
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                          " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "message.my_reservations.give_a_review"
                                                                        )
                                                                      ) +
                                                                      "\n                        "
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          !order.package_id &&
                                                          !order.subscription_id &&
                                                          !order.claimed_from
                                                            ? _c(
                                                                "button",
                                                                {
                                                                  staticClass:
                                                                    "btn btn-outline-info",
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      $event.preventDefault()
                                                                      return _vm.repeatBooking(
                                                                        order
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                          " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "message.button.repeat_booking"
                                                                        )
                                                                      ) +
                                                                      "\n                        "
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        ]
                                                      )
                                                    ]
                                                  )
                                            ]
                                          )
                                        ])
                                      ]
                                    : _vm._e()
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ])
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-center" }, [
                    _vm.state.isMore
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-info btn-block",
                            attrs: { disabled: _vm.state.isFetching },
                            on: { click: _vm.fetchOrders }
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t(_vm.isLoadMore)) +
                                "\n        "
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                ]
          ],
      _vm._v(" "),
      _c("review-modal", { ref: "reviewModal" }),
      _vm._v(" "),
      _c("received-order-modal", { ref: "receivedOrderModal" })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-183fe1f6", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-183fe1f6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/Orders.vue
// module id = 1671
// module chunks = 0